import React, {Component} from 'react'
import {
   // translate,
   setLanguage,
   // setLanguageCookie,
   getLanguage,
} from 'react-switch-lang'
import ReactCountryFlag from "react-country-flag"

const handleSetLanguage = (e, key) => {
   setLanguage(key)
   e.preventDefault()
}

class Tab extends Component{
      constructor(props) {
         super(props)
      }
      render(){
         const cl = getLanguage()
         return(
            <div className="tab-switch-language">
               <ReactCountryFlag
               svg
                   countryCode="US"
                   svg
                   style={{
                       fontSize: '35px',
                       lineHeight: '2em',
                   }}
                   onClick={(e) => handleSetLanguage(e, 'en')}
                   className={`tsl-li${cl === 'en' ? ' tsl-li-active' : ''}`}
               />
               <ReactCountryFlag
               svg
                   countryCode="TH"
                   svg
                   style={{
                       fontSize: '35px',
                       lineHeight: '2em',
                   }}
                   onClick={(e) => handleSetLanguage(e, 'th')}
                   className={`tsl-li${cl === 'th' ? ' tsl-li-active' : ''}`}
               /> 
          </div>
         )
      }
    }
   


export default Tab


// WEBPACK FOOTER //
// ./src/features/ui/components/Item/tabSwitchLanguageNoBG.js